// try auto detect, but what if rotate mobile?
// const isPC = window.innerWidth > window.innerHeight;
const isPC = false;
const resolution = isPC ? {width:1920, height:1080} : {width:540, height:760};
const folder = isPC ? "1920x1080" : "540x760";
const path = "res/" + folder;
module.exports = {
    isPC: isPC,
    folder: folder,
    path: path,
    resolution: resolution,
    screen_ratio: resolution.width / resolution.height,
    loadscreen: {
        image: path + "/loadscreen.jpg",
        loadbar:{
            position: isPC ? {x:990, y:1005} : {x:272, y:705},
            image: path + "/loadbar.png"
        }
    }
};



//////////////////
// WEBPACK FOOTER
// ./cfg/screen-config.js
// module id = 18
// module chunks = 0